import Alert from './Alert'

export default Alert
export type { AlertButton, AlertOptions, AlertStatic, AlertType } from './Alert.types'

// 导出 AlertContainer 用于 Web 端（需要在根组件中手动添加）
export { AlertContainer } from './Alert.web'
